import { stringCompare } from '../utils/trainUtils';

export const ReservationChoices = Object.freeze({
  BookIfAllBerthsAllottedInSameCoach: {
    key: 'Book, only if all berths are allotted in same coach',
    value: '1',
    warning: 'Your booking will fail if tickets are not available in the same coach.',
  },
  BookIfAtLeastOneLowerBerthsAllotted: {
    key: 'Book, only if at least 1 lower berth is allotted',
    value: '2',
    warning: 'Your booking will fail if 1 lower berth is not available.',
  },
  BookIfTwoLowerBerthsAllotted: {
    key: 'Book, only if 2 lower berths are allotted',
    value: '3',
    warning: 'Your booking will fail if 2 lower berths are not available.',
  },
  None: {
    key: 'No Preference',
    value: '99',
    warning: '',
  },
  BookConfirmAndNone: {
    key: 'BookConfirmAndNone',
    value: '4',
    warning: '',
  },
  BookConfirmAndBookIfAllBerthsAllottedInSameCoach: {
    key: 'BookConfirmAndBookIfAllBerthsAllottedInSameCoach',
    value: '5',
  },
  BookConfirmAndBookIfAtLeastOneLowerBerthsAllotted: {
    key: 'BookConfirmAndBookIfAtLeastOneLowerBerthsAllotted',
    value: '6',
  },
  BookConfirmAndBookIfTwoLowerBerthsAllotted: {
    key: 'BookConfirmAndBookIfTwoLowerBerthsAllotted',
    value: '7',
  },
});

export const ReservationChoiceValuesDefault = [ ReservationChoices.None,
  ReservationChoices.BookIfAtLeastOneLowerBerthsAllotted ];

export const ReservationChoiceForMoreThanOnePassengers = [ ReservationChoices.None,
  ReservationChoices.BookIfAllBerthsAllottedInSameCoach,
  ReservationChoices.BookIfAtLeastOneLowerBerthsAllotted,
  ReservationChoices.BookIfTwoLowerBerthsAllotted ];

export const ReservationChoiceValuesWithoutLowerBerth = [ ReservationChoices.None,
  ReservationChoices.BookIfAllBerthsAllottedInSameCoach ];

export const getRsChoiceByValue = (value) =>
  ReservationChoices[Object.keys(ReservationChoices).find((choice) =>
    stringCompare(choice.value, value))];

export const getReservationChoices = (lb, multiplePassengers=false) => {
  let choices;
  if(multiplePassengers){
    choices = ReservationChoiceForMoreThanOnePassengers;
  } else {
    choices = lb ? ReservationChoiceValuesDefault : ReservationChoiceValuesWithoutLowerBerth;
  }
  return Object.values(choices).map((choice) => ({
    id: choice.value,
    text: choice.key,
    warning:choice.warning,
    obj: choice,
  }));
};
